import * as React from 'react';
import { TreeProps } from 'antd/lib/tree';
import { Tree, Empty } from 'antd';
import { DownOutlined } from '@ant-design/icons';

import './index.less';
const { DirectoryTree } = Tree;

export type NiTreeProps = TreeProps & {};

export type NiTreeState = {};

export class NiTree extends React.Component<NiTreeProps, NiTreeState> {

  render() {
    const props = this.props;

    return (props.treeData && props.treeData.length ?
      <DirectoryTree
        switcherIcon={<DownOutlined />}
        {...props}
        icon={undefined}
        className={`ni-tree ${this.props.className}`}
      /> : <Empty
        style={{
          padding: 16,
          marginTop: 24
        }} />
    );
  }
}

